import { useEffect, useRef } from 'react'

type Handler = (event: Event) => void

export const useOutsideClick = (handler: Handler) => {
  const ref = useRef<any>(null)

  useEffect(() => {
    const handleClick = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handler(event)
      }
    }

    document.addEventListener('click', handleClick, true)
    document.addEventListener('touchstart', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
      document.removeEventListener('touchstart', handleClick, true)
    }
  }, [handler, ref])

  return ref
}
